import { Outlet } from "react-router"
import Header from "./Header"
import Footer from "./Footer";

const Layout = () => {
  return <div className="flex flex-col">
    <Header />
    <div className="flex-grow min-h-screen">
      <Outlet />
    </div>
    <Footer />
  </div>
}

export default Layout;


